// No-op implementation for web — expo-notifications uses localStorage
// which is unavailable during SSR (static rendering in Node.js).

export function configureFCMNotifications() {}

export async function registerForPushNotifications(): Promise<string | null> {
  return null;
}

export async function sendTokenToBackend(
  _token: string,
  _maxRetries?: number
): Promise<boolean> {
  return false;
}

export async function initializeFCM(): Promise<{
  token: string | null;
  registered: boolean;
}> {
  return { token: null, registered: false };
}

export async function getFCMToken(): Promise<string | null> {
  return null;
}

export async function isTokenStale(_maxAgeHours?: number): Promise<boolean> {
  return true;
}

export async function refreshFCMToken(): Promise<{
  token: string | null;
  registered: boolean;
  wasStale: boolean;
}> {
  return { token: null, registered: false, wasStale: true };
}

export async function ensureTokenRegistered(): Promise<boolean> {
  return false;
}

export function addNotificationReceivedListener(_handler: any): any {
  return { remove: () => {} };
}

export function addNotificationResponseListener(_handler: any): any {
  return { remove: () => {} };
}

export async function clearBadgeCount(): Promise<void> {}

export async function deactivateDeviceToken(): Promise<boolean> {
  return true;
}
